import { WalkI } from './../../interfaces/Walk';
import {
  OPEN_TALK,
  CLOSE_TALK,
  GET_CURRENT_WALK
} from '../constants/index'

export const openTalk = () => {
  return {
    type: OPEN_TALK,
    payload: true
  }
}

export const closeTalk = () => {
  return {
    type: CLOSE_TALK,
    payload: false
  }
}

export const getCurrentWalk = (walk: WalkI) => {
  // console.log('here')
  return {
    type: GET_CURRENT_WALK,
    payload: walk
  }
}
